<div class="flex flex-col space-y-2 md:p-4">
  <div class="grid grid-cols-3 grid-cols-[10%_30%_60%] md:grid-cols-[10%_50%_40%] mr-0.5 md:mr-0 overflow-hidden">
    <a routerLink="/energy-admin">
      <div class="pt-4.0 h-8 w-8" id="performance-back-arrow"></div>
    </a>
    <div>
      <h1 class="pt-2.5">Debug</h1>
    </div>

    <div class="flex justify-center items-center bg-gray-100 rounded-md mr-2 md:mr-0 w-auto overflow-hidden">
      <app-day-datepicker [date]="selectedDate()" (dateChange)="updateDate($event)"></app-day-datepicker>
    </div>
  </div>

  <mat-button-toggle-group
    id="performance-mode"
    [value]="selectedEnergyOption()"
    (change)="onEnergySelectionChange($event)"
    class="flex justify-center md:border-1 border-0 border-t border-b border-l-0 border-r-0 rounded-none md:rounded-lg border-gray-200"
  >
    <mat-button-toggle value="production" class="flex-1 border-gray-200 bg-production-yellow">
      Produktion
    </mat-button-toggle>
    <mat-button-toggle value="consumption" class="flex-1 border-gray-200 bg-consumption-blue">
      Verbrauch
    </mat-button-toggle>
    <mat-button-toggle value="battery" class="flex-1 border-gray-200 bg-battery-green">
      Speicher
    </mat-button-toggle>
    <mat-button-toggle value="grid" class="flex-1 border-gray-200 bg-net-black">
      Netz
    </mat-button-toggle>
  </mat-button-toggle-group>

  @if (selectedEnergyOption() === 'battery') {
    <mat-button-toggle-group
      [value]="selectedBatteryMode()"
      (change)="onBatterySelectionChange($event)"
      class="custom-switch flex justify-center border-gray-200 mr-2 ml-2 md:mr-36 md:ml-36 mb-3.5 rounded-lg"
    >
      <mat-button-toggle value="power" class="flex-1 border-gray-200 bg-consumption-blue">
        Leistung
      </mat-button-toggle>
      <mat-button-toggle value="charge" class="flex-1 border-gray-200 bg-production-yellow">
        Ladezustand (SOC)
      </mat-button-toggle>
    </mat-button-toggle-group>
  }

  <div class="pb-5">
    <app-energy-chart-debug-chart
      [type]="selectedEnergyOption()"
      [batteryMode]="selectedBatteryMode()"
      [date]="selectedDate()"
      [data]="resource.value()"
      [loading]="isLoading()"
    ></app-energy-chart-debug-chart>

    @if (isCurrentPeakPowerLoading()) {
      <div class="px-2 text-sm text-gray-600 mt-4">Lade current-peak-power-from-grid ...</div>
    }

    @if (currentPeakPowerResource.value(); as peakPower) {
      <div class="border border-gray-200 rounded-md bg-white mt-4">
        <div class="px-3 py-2 border-b border-gray-200 bg-gray-100 text-sm">
          <div class="font-semibold">current-peak-power-from-grid</div>
          <div class="text-xs text-gray-500 font-mono">
            {{ currentPeakPowerDateRange().currentMonthStart }} -> {{ currentPeakPowerDateRange().planningStart }}
          </div>
        </div>
        <div class="p-3 overflow-x-auto">
          <table class="w-full text-xs">
            <thead class="bg-gray-50 border-b border-gray-200">
              <tr>
                <th class="text-left px-2 py-1 font-semibold">field</th>
                <th class="text-right px-2 py-1 font-semibold">value</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-b border-gray-100">
                <td class="px-2 py-1 font-mono">directPeak</td>
                <td class="px-2 py-1 text-right font-mono">{{ formatPeakPowerValue(peakPower.directPeak) }}</td>
              </tr>
              <tr class="border-b border-gray-100">
                <td class="px-2 py-1 font-mono">directPeakTop3</td>
                <td class="px-2 py-1 text-right font-mono">{{ formatPeakPowerTop3(peakPower.directPeakTop3) }}</td>
              </tr>
              <tr class="border-b border-gray-100">
                <td class="px-2 py-1 font-mono">fifteenMinutePeak</td>
                <td class="px-2 py-1 text-right font-mono">{{ formatPeakPowerValue(peakPower.fifteenMinutePeak) }}</td>
              </tr>
              <tr class="border-b border-gray-100">
                <td class="px-2 py-1 font-mono">fifteenMinutePeakTop3</td>
                <td class="px-2 py-1 text-right font-mono">{{ formatPeakPowerTop3(peakPower.fifteenMinutePeakTop3) }}</td>
              </tr>
              <tr class="border-b border-gray-100">
                <td class="px-2 py-1 font-mono">dailyPeak</td>
                <td class="px-2 py-1 text-right font-mono">{{ formatPeakPowerValue(peakPower.dailyPeak) }}</td>
              </tr>
              <tr>
                <td class="px-2 py-1 font-mono">dailyPeakTop3</td>
                <td class="px-2 py-1 text-right font-mono">{{ formatPeakPowerTop3(peakPower.dailyPeakTop3) }}</td>
              </tr>
              <tr>
                <td class="px-2 py-1 font-mono">chosenMax</td>
                <td class="px-2 py-1 text-right font-mono">{{ formatPeakPowerValue(peakPower.chosenMax) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    }

    <div class="border border-gray-200 rounded-md bg-white mt-4">
      <div class="px-3 py-2 border-b border-gray-200 bg-gray-100 text-sm">
        <div class="font-semibold">energy-debug-export</div>
      </div>

      <div class="p-3 space-y-3">
        <div class="grid gap-3 lg:grid-cols-[minmax(0,1fr)_14rem_auto] items-start">
          <div>
            <label class="block text-xs font-semibold text-gray-600 mb-1">Date Range</label>
            <textarea
              class="w-full min-h-[5.5rem] border border-gray-300 rounded-md px-2 py-1 text-xs font-mono"
              [value]="exportRangeInput()"
              (input)="updateExportRangeInput($any($event.target).value)"
            ></textarea>
          </div>

          <div>
            <label class="block text-xs font-semibold text-gray-600 mb-1">Timebucket</label>
            <select
              class="w-full border border-gray-300 rounded-md px-2 py-2 text-sm bg-white"
              [value]="exportTimebucket()"
              (change)="updateExportTimebucket($any($event.target).value)"
            >
              @for (option of exportTimebucketOptions; track option) {
                <option [value]="option">{{ option }}</option>
              }
            </select>
          </div>

          <div class="flex items-end h-full">
            <button
              type="button"
              class="px-3 py-2 rounded-md bg-black text-white text-sm disabled:bg-gray-300"
              [disabled]="isExportLoading()"
              (click)="loadExportResults()"
            >
              Show Results
            </button>
          </div>
        </div>

        @if (isExportLoading()) {
          <div class="text-sm text-gray-600">Lade energy-debug-export ...</div>
        }

        @if (exportError()) {
          <div class="text-sm text-red-600">{{ exportError() }}</div>
        }

        @if (!isExportLoading() && !exportError() && exportResponse() && exportSections().length === 0) {
          <div class="text-sm text-gray-500">Keine Export-Daten gefunden.</div>
        }

        @if (exportSections().length > 0) {
          <div class="space-y-3">
            @for (section of exportSections(); track section.key) {
              <div class="border border-gray-200 rounded-md bg-white">
                <div class="px-3 py-2 border-b border-gray-200 bg-gray-100 text-sm">
                  <div class="font-semibold">{{ section.label }}</div>
                </div>
                <div class="p-3 overflow-x-auto">
                  <div class="flex space-x-3 min-w-max">
                    @for (table of section.tables; track table.id; let idx = $index) {
                      <div class="border border-gray-200 rounded-md bg-white flex-none min-w-[18rem]">
                        <div class="px-3 py-2 border-b border-gray-200 bg-gray-100 text-sm flex items-start justify-between gap-3">
                          <div class="min-w-0">
                            <div class="font-semibold break-words">{{ table.title || ('Node ' + (idx + 1)) }}</div>
                          </div>
                          <button
                            type="button"
                            class="px-2 py-1 rounded border border-gray-300 bg-white text-xs whitespace-nowrap"
                            (click)="exportTableToCsv(table)"
                          >
                            Export CSV
                          </button>
                        </div>
                        <div class="max-h-[28rem] overflow-y-auto">
                          <table class="w-full text-xs">
                            <thead class="sticky top-0 bg-gray-50 border-b border-gray-200">
                              <tr>
                                <th class="text-left px-2 py-1 font-semibold">timestamp</th>
                                <th class="text-right px-2 py-1 font-semibold">value</th>
                              </tr>
                            </thead>
                            <tbody>
                              @if (table.rows.length === 0) {
                                <tr>
                                  <td colspan="2" class="px-2 py-2 text-gray-400">Keine Zeilen fur diese Node.</td>
                                </tr>
                              } @else {
                                @for (row of table.rows; track row.timestamp + '-' + $index) {
                                  <tr class="border-b border-gray-100">
                                    <td class="px-2 py-1 align-top font-mono whitespace-nowrap">{{ formatTimestamp(row.timestamp) }}</td>
                                    <td class="px-2 py-1 align-top text-right font-mono">{{ formatExportValue(row.value) }}</td>
                                  </tr>
                                }
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
